export default __webpack_public_path__ + "static/yoga-4-fdf08dbf6a8ab7765b2de8f891f70b68.png";